export default {
  en: {
    Property: "Property",
    Type: "Type",
    Description: "Description",
    Multiplicity: "Multiplicity",
    Privacy: "Privacy",
    ClassExtensibility: "This class can be extended with additional properties."
  },
  es: {
    Property: "Propiedad",
    Type: "Tipo",
    Description: "Descripción",
    Multiplicity: "Cardinalidad",
    Privacy: "Privacidad",
    ClassExtensibility: "Esta clase se puede extender con propiedades adicionales."
  },
  ca: {
    Property: "Propietat",
    Type: "Tipus",
    Description: "Descripció",
    Multiplicity: "Cardinalitat",
    Privacy: "Privacitat",
    ClassExtensibility: "Aquesta classe es pot ampliar amb propietats adicionals."
  }
};
